import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";
import { mergeLocaleCatalogSlices } from "./merge-message-tree";
import { redblueActivityCreatePageMessages } from "./pages-activity-create";
import { redblueActivityDetailPageMessages } from "./pages-activity-detail";
import { redblueActivityLifecyclePageMessages } from "./pages-activity-lifecycle";
import { redblueActivityListPageMessages } from "./pages-activity-list";
import { redblueActivityTopologyEvidencePageMessages } from "./pages-activity-topology-evidence";

export const redblueActivityPageMessages: Record<AppLocale, MessageTree> = mergeLocaleCatalogSlices(
  [
    redblueActivityListPageMessages,
    redblueActivityCreatePageMessages,
    redblueActivityDetailPageMessages,
    redblueActivityLifecyclePageMessages,
    redblueActivityTopologyEvidencePageMessages,
  ],
);
